import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

/**
 * Deletes a contact from a supplier relationship.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param contactId - The ID of the contact to delete.
 * @param options - Optional ky request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/delete_supplier_contact_suppliers_details__de_id__contacts__contact_id__delete
 */
export const deleteSupplierContact = async (
  deId: UUID,
  contactId: UUID,
  options?: KyRequestOptions,
) => {
  await vestigasApi.delete(
    ENDPOINT.SUPPLIER.DELETE_CONTACT(deId, contactId),
    options,
  );
};
